// Actualiza a variante selecionada (ex: modelo de iPhone) sem recarregar a página.
document.addEventListener('DOMContentLoaded', function () {
  var ids = window.__productSections || [];
  ids.forEach(function (sectionId) {
    var form = document.getElementById('ProductForm-' + sectionId);
    if (!form) return;

    var jsonEl = document.getElementById('ProductJSON-' + sectionId);
    if (!jsonEl) return;
    var variants;
    try {
      variants = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }

    var selects = form.querySelectorAll('.option-select');
    var hiddenId = document.getElementById('ProductSelectedVariant-' + sectionId);
    var priceEl = document.getElementById('ProductPrice-' + sectionId);
    var addBtnText = document.getElementById('AddToCartText-' + sectionId);
    var addBtn = document.getElementById('AddToCart-' + sectionId);

    function formatMoney(cents) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }

    function currentOptions() {
      var opts = [];
      selects.forEach(function (sel) {
        opts.push(sel.value);
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        var vOpts = [v.option1, v.option2, v.option3].filter(function (o) { return o !== null && o !== undefined; });
        return vOpts.every(function (o, i) { return o === opts[i]; });
      });
    }

    function updateVariant() {
      var opts = currentOptions();
      var match = findVariant(opts);
      if (!match) return;
      hiddenId.value = match.id;
      if (priceEl) priceEl.textContent = formatMoney(match.price);
      if (match.available) {
        addBtn.removeAttribute('disabled');
        addBtnText.textContent = 'Adicionar ao Carrinho';
      } else {
        addBtn.setAttribute('disabled', 'disabled');
        addBtnText.textContent = 'Esgotado';
      }
    }

    selects.forEach(function (sel) {
      sel.addEventListener('change', updateVariant);
    });
  });
});
